/*
  Gaveta de carrinho.

  A REGRA QUE ORGANIZA ESTE ARQUIVO: o JavaScript nao desenha nada.

  Toda mudanca no carrinho pede a Shopify para renderizar a secao `cart-drawer` de novo,
  em Liquid, e troca o HTML por inteiro. E a Section Rendering API, e e o caminho oficial.

  A alternativa, que e o que a maioria dos temas faz, seria montar as linhas do carrinho
  em JavaScript a partir do JSON. Isso obriga a reescrever aqui, em outra linguagem, a
  formatacao de moeda, a regra de frete gratis, a exclusao do que ja esta no carrinho e o
  calculo de quanto falta. Duas implementacoes da mesma regra divergem, sempre, e a que
  diverge e a que o cliente ve.

  SEM ESTE ARQUIVO A LOJA CONTINUA FUNCIONANDO. O formulario de compra e um <form> de
  verdade que posta para /cart, e a pagina de carrinho existe e esta construida. Tudo
  aqui e progressive enhancement: nada de `preventDefault` antes de saber que deu certo.

  OS TRES GANCHOS QUE O RESTO DO TEMA USA

    data-cart-open        abre a gaveta em vez de navegar para /cart
    data-add="ID"         adiciona uma variante e abre a gaveta
    data-add-many="..."   adiciona VARIAS de uma vez, numa chamada so, em captura.
                          Formato: "44123:1,44987:2" ou "44123,44987" (quantidade 1).
                          E o gancho de "Add the pair" (PDP e colecao) e de
                          "Add all three" (indice de cortes da home).

  Um <form> que poste para /cart/add com campos `items[0][id]`, `items[0][quantity]`,
  `items[1][id]`... tambem funciona, e e o caminho sem JavaScript de "Add all three":
  o endpoint aceita o array, e este arquivo le o mesmo formato antes de mandar por Ajax.

  QUEM NAO E INTERCEPTADO: qualquer formulario dentro de `[data-cart-page]`. Numa pagina
  de carrinho a gaveta abriria por cima da propria lista e deixaria a lista de tras
  desatualizada; ali o recarregamento e o comportamento certo.
*/

(function () {
  'use strict';

  var SECAO = 'cart-drawer';
  var raiz = function () { return document.getElementById('cart-drawer'); };
  var dialogo = function () { var r = raiz(); return r && r.querySelector('dialog.drawer'); };

  // As rotas vem do Liquid, em atributo na raiz da gaveta, e nao digitadas aqui: com
  // Markets, ou com um idioma de prefixo, `/cart/add.js` cru cai fora do caminho da
  // loja e a chamada volta 404 sem dizer por que.
  function rota(nome, reserva) {
    var r = raiz();
    var v = r && r.getAttribute(nome);
    return v ? v : reserva;
  }

  // Guarda quem abriu a gaveta, para devolver o foco no fechamento. O <dialog> devolve
  // sozinho quando aberto por showModal, mas nao quando o HTML e trocado embaixo dele.
  var origem = null;

  // O endereco do controle clicado, para devolver o foco ao MESMO botao depois que o
  // HTML e trocado. Sem isto, cada clique no mais ou no menos joga quem navega por
  // teclado de volta ao topo da gaveta, e mudar de 1 para 3 vira uma peregrinacao.
  var chaveFoco = null;

  // Regiao de aviso PERMANENTE, fora da arvore que e trocada. Um aria-live que nasce
  // junto com o conteudo novo nao anuncia nada: leitor de tela so anuncia mudanca
  // dentro de uma regiao que ja existia antes. Por isso ela mora no body e sobrevive a
  // todas as trocas.
  var viva = null;
  function regiaoViva() {
    if (viva && document.contains(viva)) return viva;
    viva = document.createElement('p');
    viva.className = 'visually-hidden';
    viva.setAttribute('aria-live', 'polite');
    viva.setAttribute('role', 'status');
    document.body.appendChild(viva);
    return viva;
  }

  function abrir() {
    var d = dialogo();
    if (!d) return;
    if (!d.open) d.showModal();
    // A rolagem do fundo trava aqui, e nao no CSS: `:has()` sobre o body ainda falha em
    // navegador de celular antigo, e gaveta que deixa a pagina rolar atras e a
    // reclamacao numero um.
    document.body.style.overflow = 'hidden';
  }

  function fechar() {
    var d = dialogo();
    if (d && d.open) d.close();
    document.body.style.overflow = '';
    if (origem && document.contains(origem)) origem.focus();
  }

  // Troca o conteudo da gaveta pelo HTML que a Shopify acabou de renderizar.
  function trocar(html) {
    var antigo = raiz();
    if (!antigo || !html) return;

    var estavaAberta = !!(dialogo() && dialogo().open);
    var listaAnterior = antigo.querySelector('.lines');
    var posicaoLista = listaAnterior ? listaAnterior.scrollTop : 0;
    var eraFoco = chaveFoco;
    chaveFoco = null;

    var molde = document.createElement('div');
    molde.innerHTML = html;
    var novo = molde.querySelector('#cart-drawer');
    if (!novo) return;

    antigo.replaceWith(novo);

    // O contador do cabecalho vem do proprio HTML renderizado, e nao de uma segunda
    // consulta: um numero so, vindo de uma fonte so.
    var n = parseInt(novo.getAttribute('data-cart-count'), 10);
    if (!isNaN(n)) {
      document.querySelectorAll('[data-cart-count-target]').forEach(function (el) {
        el.textContent = n > 0 ? n : '';
        el.hidden = n === 0;
      });
      document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
        el.textContent = 'Cart, ' + n + (n === 1 ? ' item' : ' items');
      });
    }

    if (estavaAberta) {
      // FREIO DA ANIMACAO. A gaveta ja esta na tela: trocar o conteudo nao e abrir de
      // novo. Como o `#cart-drawer` inteiro e substituido, o <dialog> passa a ser outro
      // elemento, e o `showModal` abaixo faria a animacao de `[open]` recomecar a cada
      // clique no mais ou no menos. Com a classe, a gaveta so desliza quando de fato
      // entra, e o conteudo troca no lugar.
      var novoDialogo = novo.querySelector('dialog.drawer');
      if (novoDialogo) novoDialogo.classList.add('drawer--nofx');
      abrir();
      // O <dialog> reaberto manda o foco para o primeiro controle. Se o botao clicado
      // ainda existe no HTML novo, o foco volta para ele; se a linha sumiu porque a
      // quantidade chegou a zero, o fechar e o destino seguro, e o foco fica dentro do
      // dialogo modal, que e de onde ele nao pode sair.
      var alvo = eraFoco ? novo.querySelector('[data-key="' + eraFoco + '"]') : null;
      if (!alvo) alvo = novo.querySelector('.drawer__close');
      if (alvo) alvo.focus({ preventScroll: true });
      var novaLista = novo.querySelector('.lines');
      if (novaLista) novaLista.scrollTop = posicaoLista;
    }

    // O aviso sai da propria arvore renderizada, entao ha um numero so, vindo de uma
    // fonte so, tambem para quem ouve a pagina.
    var total = novo.getAttribute('data-cart-total');
    if (!isNaN(n)) {
      regiaoViva().textContent =
        'Cart updated. ' + n + (n === 1 ? ' item' : ' items') + (total ? ', subtotal ' + total : '') + '.';
    }
  }

  function avisar(msg) {
    var d = dialogo();
    if (!d) { window.alert(msg); return; }
    var alvo = d.querySelector('[data-drawer-error]');
    if (!alvo) {
      alvo = document.createElement('p');
      alvo.setAttribute('data-drawer-error', '');
      alvo.setAttribute('role', 'alert');
      alvo.className = 'drawer__erro';
      var cabeca = d.querySelector('.drawer__head');
      if (cabeca) cabeca.insertAdjacentElement('afterend', alvo);
    }
    alvo.textContent = msg;
  }

  // Um caminho unico para toda mutacao de carrinho: montar corpo, pedir a secao de volta,
  // trocar o HTML, abrir. Adicionar, mudar quantidade e remover passam todos por aqui.
  function mutar(url, corpo, botao) {
    if (botao) botao.setAttribute('aria-busy', 'true');

    corpo.sections = SECAO;
    corpo.sections_url = window.location.pathname;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, dados: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          // A Shopify devolve `description` quando o estoque nao cobre a quantidade.
          // ERRO NEM SEMPRE E "NADA ACONTECEU": com estoque parcial ela responde 422 e
          // mesmo assim poe no carrinho o que tinha ("Only 4 items were added"). Sem pedir
          // a secao de novo, a gaveta mostrava "Your cart is empty" com 4 potes dentro
          // (achado na loja real em 02/10/2026, Mexicana com 4 em estoque). A secao volta pela
          // mesma Section Rendering API, e o aviso entra DEPOIS da troca, porque a troca
          // substitui a arvore onde ele mora.
          // O pedido da secao vai SEM cabecalho Accept: numa URL de produto, com
          // `Accept: application/json`, a Shopify devolve o JSON do produto (chave
          // "product") e nao a secao, e a gaveta ficava sem HTML (medido em 02/10). Sem
          // cache, e a contagem da secao conferida com o /cart.js; se nao bater, tenta de
          // novo apos uma pausa curta, no maximo tres vezes.
          var msg = res.dados.description || res.dados.message || 'Could not update the cart.';
          var semCache = { cache: 'no-store' };
          var buscar = function (tentativa) {
            return Promise.all([
              fetch(window.location.pathname + '?sections=' + SECAO + '&t=' + Date.now(), semCache)
                .then(function (r) { return r.ok ? r.json() : null; }),
              fetch(rota('data-cart-url', '/cart') + '.js', semCache)
                .then(function (r) { return r.ok ? r.json() : null; }),
            ]).then(function (par) {
              var html = par[0] && par[0][SECAO];
              var m = html ? html.match(/data-cart-count="(\d+)"/) : null;
              var naSecao = m ? parseInt(m[1], 10) : NaN;
              var noCarrinho = par[1] ? par[1].item_count : NaN;
              if (html && naSecao !== noCarrinho && tentativa < 3) {
                return new Promise(function (ok) { setTimeout(ok, 400 * tentativa); })
                  .then(function () { return buscar(tentativa + 1); });
              }
              return html;
            });
          };
          return buscar(1)
            .catch(function () { return null; })
            .then(function (html) {
              if (html) trocar(html);
              avisar(msg);
              abrir();
            });
        }
        // Na propria pagina de carrinho a lista de tras e a fonte da verdade: trocar so
        // a gaveta deixaria a pagina mostrando um pedido que nao existe mais. Aqui o
        // recarregamento e o comportamento certo, como no envio de formulario.
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        if (res.dados.sections && res.dados.sections[SECAO]) trocar(res.dados.sections[SECAO]);
        abrir();
      })
      .catch(function () {
        // Rede caiu: manda para a pagina de carrinho, que funciona sem nada disto.
        window.location.href = rota('data-cart-url', '/cart');
      })
      .finally(function () {
        if (botao) botao.removeAttribute('aria-busy');
      });
  }

  // "44123:1,44987:2" e "44123,44987" viram os dois a mesma lista de itens. Quantidade
  // ausente, zero ou ilegivel vale 1: um botao de "Add the pair" que adiciona zero potes
  // por causa de um atributo mal escrito falha calado, que e a pior forma de falhar.
  function itensDe(texto) {
    var itens = [];
    (texto || '').split(',').forEach(function (parte) {
      var pedacos = parte.split(':');
      var id = (pedacos[0] || '').trim();
      if (!id) return;
      var q = parseInt(pedacos[1], 10);
      itens.push({ id: id, quantity: isNaN(q) || q < 1 ? 1 : q });
    });
    return itens;
  }

  // ---- Adicionar ao carrinho, a partir de um formulario de produto ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!raiz()) return; // sem gaveta na pagina, deixa o formulario seguir normal
    if (form.closest('[data-cart-page]')) return; // na propria pagina de carrinho, recarrega

    e.preventDefault();
    origem = form.querySelector('[type="submit"]');

    var dados = {};
    var muitos = {};
    new FormData(form).forEach(function (valor, chave) {
      // `sections` e reservado do nosso lado, e o form nunca deveria mandar isso.
      if (chave === 'sections' || chave === 'sections_url') return;
      // Formato de varios itens do proprio endpoint: items[0][id], items[0][quantity].
      var m = chave.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (m) {
        muitos[m[1]] = muitos[m[1]] || {};
        muitos[m[1]][m[2]] = valor;
        return;
      }
      dados[chave] = valor;
    });

    var itens = Object.keys(muitos)
      .map(function (k) {
        var q = parseInt(muitos[k].quantity, 10);
        return { id: muitos[k].id, quantity: isNaN(q) || q < 1 ? 1 : q };
      })
      .filter(function (i) { return i.id; });

    if (!itens.length) {
      if (!dados.id) return;
      itens = [{ id: dados.id, quantity: parseInt(dados.quantity || 1, 10) || 1 }];
    }

    mutar(rota('data-add-url', '/cart/add') + '.js', { items: itens }, origem);
  });

  // ---- Varios de uma vez, em CAPTURA ----
  //
  // Este ramo roda na fase de captura, antes de qualquer ouvinte de clique no
  // documento, e interrompe a propagacao. Ate 05/09 isso era uma trava contra um
  // segundo ouvinte de `[data-add-many]` que vivia em `main-product.liquid` e mandava
  // uma chamada de adicao a mais no mesmo clique: "Add the pair" colocava quatro potes
  // no carrinho, sem erro nenhum na tela. Aquele trecho foi removido, e a captura fica
  // como regra da casa: este arquivo e o dono unico do atributo, em qualquer secao que
  // o emita, e nenhuma secao precisa saber da existencia das outras para nao colidir.
  document.addEventListener(
    'click',
    function (e) {
      if (!(e.target instanceof Element)) return;
      var lote = e.target.closest('[data-add-many]');
      if (!lote || !raiz()) return;
      var itens = itensDe(lote.getAttribute('data-add-many'));
      if (!itens.length) return;
      e.preventDefault();
      e.stopPropagation();
      origem = lote;
      chaveFoco = lote.getAttribute('data-key');
      mutar(rota('data-add-url', '/cart/add') + '.js', { items: itens }, lote);
    },
    true
  );

  // ---- Cliques dentro e fora da gaveta ----
  document.addEventListener('click', function (e) {
    // `closest` so existe em Element: clique que cai num nó que nao e elemento
    // derrubaria o ouvinte inteiro, e com ele a gaveta.
    if (!(e.target instanceof Element)) return;

    // Abrir pelo icone do cabecalho, em vez de navegar para /cart.
    var gatilho = e.target.closest('[data-cart-open]');
    if (gatilho && raiz()) {
      e.preventDefault();
      origem = gatilho;
      abrir();
      return;
    }

    if (e.target.closest('[data-drawer-close]')) { fechar(); return; }

    if (e.target.closest('[data-cart-suggestions]')) {
      var tituloSugestoes = raiz().querySelector('[data-cart-suggestion-heading]');
      if (tituloSugestoes) {
        tituloSugestoes.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        tituloSugestoes.focus({ preventScroll: true });
      }
      return;
    }

    // Quantidade. `data-qty` ja vem com o valor FINAL calculado em Liquid, entao nao ha
    // estado para o JavaScript guardar nem para divergir.
    var passo = e.target.closest('[data-change]');
    if (passo) {
      origem = passo;
      chaveFoco = passo.getAttribute('data-key');
      mutar(
        rota('data-change-url', '/cart/change') + '.js',
        { line: parseInt(passo.getAttribute('data-change'), 10), quantity: parseInt(passo.getAttribute('data-qty'), 10) },
        passo
      );
      return;
    }

    // "Add the pair" e "Add all three" sao tratados na fase de captura, mais acima.

    // Adicionar direto de uma sugestao de frete gratis, sem sair da gaveta.
    var atalho = e.target.closest('[data-add]');
    if (atalho && raiz()) {
      e.preventDefault();
      origem = atalho;
      chaveFoco = atalho.getAttribute('data-key');
      mutar(rota('data-add-url', '/cart/add') + '.js', { items: [{ id: atalho.getAttribute('data-add'), quantity: 1 }] }, atalho);
      return;
    }

    // Clique no fundo escuro fecha. O <dialog> recebe o clique do ::backdrop nele
    // mesmo, entao basta conferir que o alvo e o proprio dialogo e nao algo dentro.
    var d = dialogo();
    if (d && e.target === d) fechar();
  });

  // O Escape e nativo do <dialog>. So falta destravar a rolagem do fundo.
  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('drawer')) {
      document.body.style.overflow = '';
    }
  }, true);
})();
